<template>
    <div class="contact-linked-companies typographies-paragraph-medium-bold">
        <template v-for="(company, index) in companiesToDisplay" :key="index">
            <CompassLink type="secondary" :link="company.link" v-html="company.name" />
            <span v-if="index < companies.length - 1" :key="company.name">,&nbsp;</span>
        </template>
        <button
            v-if="!showRemaining && hasMoreThan5Companies"
            class="contact-linked-companies__button"
            @click.prevent.stop="handleShowRemaing"
        >
            + {{ remainingCompanies }} {{ $l10n.__('autres') }}
        </button>
    </div>
</template>
<script>
export default {
    props: {
        companies: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            showRemaining: false,
        };
    },
    computed: {
        remainingCompanies() {
            return this.companies.slice(5).length;
        },
        hasMoreThan5Companies() {
            return this.companies.length > 5;
        },
        companiesToDisplay() {
            return this.showRemaining && this.hasMoreThan5Companies
                ? this.companies
                : this.companies.slice(0, 5);
        },
    },
    methods: {
        handleShowRemaing() {
            this.showRemaining = true;
        },
    },
};
</script>
<style lang="scss" scoped>
.contact-linked-companies {
    display: flex;
    flex-wrap: wrap;

    &__button {
        background: transparent;
        border: 0;
        color: var(--colors-common-text-subtle-default, #565665);
        cursor: pointer;
        font-weight: 600;
        padding: 0;

        &:hover {
            color: var(--colors-common-text-subtle-hover, #111111);
        }
    }
}
</style>
